module.exports = __webpack_public_path__ + "media/images/loader-onwhite-56722e7c75e27b88806c15b47c747661.svg";